import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class VenueService {

  rootUri = (environment.ktRootUri) ? environment.ktRootUri : "";

  constructor(private http: HttpClient) { }

  getVenueDetails(filter_type: string, filter_value: any): Observable<Venue> {
    return this.http.get<Venue>(`${this.rootUri}/api/venue/fetch`, {
      params: {
        filter_type,
        filter_value
      }
    });
  }

  updateVenue(venue_id: number, venueData: any): Observable<Venue> {
    return this.http.post<Venue>(`${this.rootUri}/api/venue/${venue_id}/update`, venueData);
  }

  createVenue(venueData: any): Observable<Venue> {
    return this.http.post<Venue>(`${this.rootUri}/api/venue/create`, venueData);
  }

  uploadVenueImage(venue_id: number, imageData: FormData): Observable<string> {
    return this.http.post<string>(`${this.rootUri}/api/venue/${venue_id}/upload-image`, imageData);
  }

}
